"use client"

import { useState } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Sidebar from "./components/Sidebar"
import Home from "./pages/Home"
import MusicLyrics from "./pages/musicLyrics"
import { motion , AnimatePresence } from "framer-motion"
import VideoDownloader from "./pages/VideoDownloader"
import InstagramDownloader from "./pages/instagramDownloader"
import FacebookDownloader from "./pages/facebookDownloader"
import YouTubeDownloader from "./pages/youtubdownloader"
import TikTokDownloader from "./pages/tiktokdownloader"
import ProgrammingMemesGenerator from "./pages/memesGenerator"
import AudioToText from "./pages/audioTotext"
import QuotesGenerator from "./pages/quotesGenerator"
import AISkinBeauty from "./pages/aiskinbeauty"
import NotFound from "./pages/Notfound"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import Footer from "./components/Footer"
import FeedbackPage from "./pages/FeedbackPage"

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem("darkMode")
    return savedMode ? JSON.parse(savedMode) : false
  })
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const toggleDarkMode = () => {
    setDarkMode(!darkMode)
  }

  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(darkMode))
    if (darkMode) {
      document.documentElement.classList.add("dark")
    } else {
      document.documentElement.classList.remove("dark")
    }
  }, [darkMode])

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  return (
    <BrowserRouter>
      <div className={`flex h-screen ${darkMode ? "dark" : ""}`}>
        <Sidebar
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
          isOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
        />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-gray-900 transition-colors duration-200">
          <AnimatePresence mode="wait">
            <Routes>
              <Route
                path="/"
                element={
                  <PageWrapper>
                    <Home />
                  </PageWrapper>
                }
              />
              <Route
                path="/lyrics-finder"
                element={
                  <PageWrapper>
                    <MusicLyrics />
                  </PageWrapper>
                }
              />
              <Route
                path="/video-downloader"
                element={
                  <PageWrapper>
                    <VideoDownloader />
                  </PageWrapper>
                }
              />
              <Route
                path="/video-downloader/instagram"
                element={
                  <PageWrapper>
                    <InstagramDownloader />
                  </PageWrapper>
                }
              />
              <Route
                path="/video-downloader/facebook"
                element={
                  <PageWrapper>
                    <FacebookDownloader />
                  </PageWrapper>
                }
              />
              <Route
                path="/video-downloader/youtube"
                element={
                  <PageWrapper>
                    <YouTubeDownloader />
                  </PageWrapper>
                }
              />
              <Route
                path="/video-downloader/tiktok"
                element={
                  <PageWrapper>
                    <TikTokDownloader />
                  </PageWrapper>
                }
              />
              <Route
                path="/programming-memes"
                element={
                  <PageWrapper>
                    <ProgrammingMemesGenerator />
                  </PageWrapper>
                }
              />
              <Route
                path="/audio-to-text"
                element={
                  <PageWrapper>
                    <AudioToText />
                  </PageWrapper>
                }
              />
              <Route
                path="/quotes-generator"
                element={
                  <PageWrapper>
                    <QuotesGenerator />
                  </PageWrapper>
                }
              />
              <Route
                path="/ai-skin-beauty"
                element={
                  <PageWrapper>
                    <AISkinBeauty />
                  </PageWrapper>
                }
              />
              <Route
                path="/feedback"
                element={
                  <PageWrapper>
                    <FeedbackPage />
                  </PageWrapper>
                }
              />
              <Route
                path="*"
                element={
                  <PageWrapper>
                    <NotFound />
                  </PageWrapper>
                }
              />
            </Routes>
          </AnimatePresence>
        </main>
      </div>
    </BrowserRouter>
  )
}

const PageWrapper = ({ children }) => {
  const location = useLocation()
  return (
    <>
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
    <Footer/>
    </>

  )
}

export default App





